const games = [
  {
    name: "Minecraft ONLINE",
    url: "https://classic.minecraft.net/",
  },
  {
    name: "F1",
    url: "https://games.crazygames.com/fr_FR/super-star-car/index.html",
  },
  {
    name: "Rallye",
    url: "https://www.addictinggames.com/embed/html5-games/25029",
  },
  {
    name: "Assault bots",
    url: "https://games.crazygames.com/en_US/bot-machines/index.html",
  },
  {
    name: "Smash karts",
    url: "https://games.crazygames.com/en_US/smash-karts/index.html",
  },
  {
    name: "Crazy roll",
    url: "https://games.crazygames.com/en_US/crazy-roll-3d/index.html",
  },
  {
    name: "Drift boss",
    url: "https://games.crazygames.com/en_US/drift-boss/index.html",
  },
  {
    name: "Poor fortnite",
    url: "https://games.crazygames.com/en_US/buildnow-gg/index.html",
  },
  {
    name: "CSGO",
    url: "https://games.crazygames.com/en_US/bullet-force-multiplayer/index.html",
  },
  {
    name: "GTA",
    url: "https://games.crazygames.com/fr_FR/project-grand-auto-town/index.html",
  },
];

export default games;
